import * as React from 'react';
import { useApplicationContext } from '../utils/applicationContext';
import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import {
  MAX_DISPLAY_QUESTIONS_ONBOARDING_COUNT,
  QUESTIONS_CONFIG_KEY,
  QUESTIONS_ONBOARDING_CONFIG_KEY,
  QUESTIONS_ONBOARDING_COOKIE_KEY,
} from '../constants/questions';

interface IQuestionsFeature {
  isQuestionsFeatureEnabled: boolean;
  isOnboardingShown: boolean;
  setIsOnboardingShown(value: boolean): void;
  onOnboardingShown(): void;
}

export const useQuestionsFeature = (): IQuestionsFeature => {
  const { config } = useApplicationContext();
  // TODO isQuestionsFeatureEnabled убрать в CD-168127
  const isQuestionsFeatureEnabled = config.getStrict(QUESTIONS_CONFIG_KEY) as boolean;
  const isOnboardingEnabled = config.getStrict(QUESTIONS_ONBOARDING_CONFIG_KEY) as boolean;

  const [timesShown, setTimesShown] = React.useState(getOnboardingCookie());
  const [isOnboardingShown, setIsOnboardingShown] = React.useState(
    timesShown < MAX_DISPLAY_QUESTIONS_ONBOARDING_COUNT && isOnboardingEnabled,
  );

  const onOnboardingShown = () => {
    if (timesShown > MAX_DISPLAY_QUESTIONS_ONBOARDING_COUNT) {
      return;
    }
    const times = timesShown + 1;
    setTimesShown(times);
    setOnboardingCookie(times);
  };

  return { isQuestionsFeatureEnabled, isOnboardingShown, setIsOnboardingShown, onOnboardingShown };
};

function getOnboardingCookie() {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return 0;
  }

  const matches = window.document.cookie.match(
    new RegExp(`(?:^|; )${QUESTIONS_ONBOARDING_COOKIE_KEY.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`),
  );
  const cookie = matches ? decodeURIComponent(matches[1]) : undefined;

  return Number(cookie) || 0;
}

function setOnboardingCookie(times: number) {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };
  const isLocalhost = typeof window !== undefined && window.location.hostname.indexOf('localhost') > -1;

  if (isLocalhost) {
    cookieConfig.domain = 'localhost';
  }

  setCookie(QUESTIONS_ONBOARDING_COOKIE_KEY, `${times}`, cookieConfig);
}
